module.exports = __webpack_public_path__ + "static/img/ios.c207de29.png";